import { Controller } from "@hotwired/stimulus"
import SimpleBar from "simplebar"

// The sidebar is data-turbo-permanent: on every Turbo render it is moved from
// the old page into the new one, so Stimulus disconnects and reconnects it.
// Taking it out of the document resets SimpleBar's scroll position, so the
// position is saved just before the render and restored on connect.
let savedScrollTop = 0

export default class extends Controller {
  static targets = ["scroller", "link"]

  connect() {
    if (!this.scrollerTarget.querySelector(".simplebar-content")) {
      new SimpleBar(this.scrollerTarget)
    }
    this.markActiveLink()

    // After a full page load nothing is saved, so the active link may be below
    // the fold (e.g. "Fotowoltaika") - bring it into view instead.
    if (savedScrollTop) {
      this.scrollWrapper.scrollTop = savedScrollTop
    } else {
      this.revealActiveLink()
    }

    this.saveScroll = () => { savedScrollTop = this.scrollWrapper?.scrollTop || 0 }
    document.addEventListener("turbo:before-render", this.saveScroll)
  }

  disconnect() {
    document.removeEventListener("turbo:before-render", this.saveScroll)
  }

  get scrollWrapper() {
    return this.scrollerTarget.querySelector(".simplebar-content-wrapper")
  }

  // Highlights the section of the current page (by the first path segment).
  markActiveLink() {
    const current = window.location.pathname.split("/")[1] || ""

    this.linkTargets.forEach((link) => {
      const segment = (link.getAttribute("href") || "").split("/")[1] || ""
      link.closest(".sidebar-item")?.classList.toggle("active", segment !== "" && segment === current)
    })
  }

  // Scrolls only the sidebar (not the page) so the active item sits in its lower part.
  revealActiveLink() {
    const wrapper = this.scrollWrapper
    const item = this.element.querySelector(".sidebar-item.active")
    if (!wrapper || !item) return

    const itemBottom = item.getBoundingClientRect().bottom - wrapper.getBoundingClientRect().top
    if (itemBottom > wrapper.clientHeight) {
      wrapper.scrollTop += itemBottom - wrapper.clientHeight + item.offsetHeight
    }
  }
}
